import { FilterModel, MultiSelect } from '@empathy/search-types';
import { replaceBehaviour } from '@empathybroker/deep-merge';
import { COMPONENTS } from '../../../components/components.registry';
import { FacetsConfig, FacetsGroupConfig, ShowSelectedFilters, SLOTS } from '../../../models';
import { DeepPartial, Dictionary } from '../../../utils';

export const DEFAULT_FACETS_CONFIG: FacetsConfig = {
  default: {
    facet: {
      components: {
        facet: COMPONENTS.PURE.DefaultFacet,
        beforeFilters: null,
        facetSearch: {
          search: COMPONENTS.PURE.FacetSearch,
          icon: COMPONENTS.PURE.SearchIcon,
          clear: COMPONENTS.PURE.CrossIcon
        },
        filters: null,
        filter: {
          filter: COMPONENTS.PURE.CheckBoxFilter,
          title: COMPONENTS.PURE.FilterTitle,
          checkbox: null
        },
        selectedFilters: {
          selectedFilters: COMPONENTS.PURE.SelectedFilters,
          filterTitle: COMPONENTS.PURE.FilterTitle,
          removeIcon: COMPONENTS.PURE.CrossIcon
        },
        icon: null,
        header: null,
        footer: null
      },
      slots: {
        selectedFilters: SLOTS.facet.header
      },
      mapping: {
        multiSelectable: MultiSelect.Disabled,
        showUnselectedValues: true,
        isDynamic: false,
        filterModelName: FilterModel.simple
      },
      collapsible: true,
      showMoreButton: false,
      showSelectedFilters: ShowSelectedFilters.Never,
      filtersToShow: 5,
      startCollapsed: false,
      searchable: {
        enabled: false,
        toggleable: true,
        startsOpen: false,
        facetsFilterRegex: '{query}'
      },
      compulsory: false,
      renderChildren: true,
      useIndexAsFilterKey: false
    },
    group: {
      components: {
        panel: COMPONENTS.PANELS.OverlappingPanel,
        close: COMPONENTS.PANELS.PanelToggle,
        clear: COMPONENTS.PURE.ClearFacetsFilters,
        toggle: COMPONENTS.PANELS.PanelToggle,
        header: null,
        footer: null,
        selectedFilters: {
          selectedFilters: null,
          removeIcon: COMPONENTS.PURE.CrossIcon
        }
      },
      facets: {},
      addRemainingFacets: false,
      excludeFromRemainingFacets: [],
      collapsible: true,
      slidingDirection: 'top',
      startCollapsed: true,
      layoutDirection: 'horizontal',
      templateSlots: {
        panel: SLOTS.template.overlay,
        toggle: SLOTS.template.toolbar
      },
      slots: {
        close: SLOTS.facetsGroup.footer,
        clear: SLOTS.facetsGroup.header,
        selectedFilters: SLOTS.facetsGroup.footer
      }
    }
  },
  facets: {
    price: {
      mapping: { filterModelName: FilterModel.currencyRange }
    },
    price_facet: {
      mapping: { filterModelName: FilterModel.currencyRange }
    },
    color_facet: {
      components: {
        filter: { checkbox: COMPONENTS.PURE.SolidCheckbox }
      }
    }
  },
  groups: replaceBehaviour<DeepPartial<Dictionary<FacetsGroupConfig>>>({
    'all-facets': {
      addRemainingFacets: true
    }
  })
};
